var _rect, _rect2, _rect3, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _rect4, _polygon6, _polygon7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPA1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 990 720"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-id": "A.1.1",
    x: 249,
    y: 380,
    width: 90,
    height: 128
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    "data-id": "A.1.2",
    x: 96,
    y: 380,
    width: 148.03,
    height: 128
  })), ">\n    ", _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    "data-id": "A.1.3",
    x: 85.05,
    y: 182,
    width: 130.95,
    height: 193
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.1.4",
    points: "221.21 182 339 182 339 339 247 339 247 329 221 329 221 182 221.21 182"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.1.5",
    points: "344 199 462 199 462 329 437 329 437 339 344 339 344 199"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.1.6",
    points: "466.88 199 585 199 585 340 492.74 340 492.74 329 466.88 329 466.88 199"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.1.7",
    points: "589.87 199 708 199 708 329 682 329 682 339 589.87 339 589.87 199"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.1.8",
    points: "713 211 892 211 892 375 810.55 375 810.55 339 713 339 713 211"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    "data-id": "A.1.9",
    x: 712.66,
    y: 380,
    width: 191.34,
    height: 158
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.1.10",
    points: "708 380 708 538 589.98 538 589.98 390 615 390 615 380 708 380"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.1.11",
    points: "585 390.46 585 520 466.74 520 466.74 380 559 380 559 390 585 390.46"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyAKICAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgCiAgICB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgCiAgICB2aWV3Qm94PSIwIDAgOTkwIDcyMCIKPgogICAgPHJlY3QgZGF0YS1pZD0iQS4xLjEiIHg9IjI0OSIgeT0iMzgwIiB3aWR0aD0iOTAiIGhlaWdodD0iMTI4Ii8+CiAgICA8cmVjdCBkYXRhLWlkPSJBLjEuMiIgeD0iOTYiIHk9IjM4MCIgd2lkdGg9IjE0OC4wMyIgaGVpZ2h0PSIxMjgiLz4+CiAgICA8cmVjdCBkYXRhLWlkPSJBLjEuMyIgeD0iODUuMDUiIHk9IjE4MiIgd2lkdGg9IjEzMC45NSIgaGVpZ2h0PSIxOTMiLz4KICAgIDxwb2x5Z29uIGRhdGEtaWQ9IkEuMS40IiBwb2ludHM9IjIyMS4yMSAxODIgMzM5IDE4MiAzMzkgMzM5IDI0NyAzMzkgMjQ3IDMyOSAyMjEgMzI5IDIyMSAxODIgMjIxLjIxIDE4MiIvPgogICAgPHBvbHlnb24gZGF0YS1pZD0iQS4xLjUiIHBvaW50cz0iMzQ0IDE5OSA0NjIgMTk5IDQ2MiAzMjkgNDM3IDMyOSA0MzcgMzM5IDM0NCAzMzkgMzQ0IDE5OSIvPgogICAgPHBvbHlnb24gZGF0YS1pZD0iQS4xLjYiIHBvaW50cz0iNDY2Ljg4IDE5OSA1ODUgMTk5IDU4NSAzNDAgNDkyLjc0IDM0MCA0OTIuNzQgMzI5IDQ2Ni44OCAzMjkgNDY2Ljg4IDE5OSIvPgogICAgPHBvbHlnb24gZGF0YS1pZD0iQS4xLjciIHBvaW50cz0iNTg5Ljg3IDE5OSA3MDggMTk5IDcwOCAzMjkgNjgyIDMyOSA2ODIgMzM5IDU4OS44NyAzMzkgNTg5Ljg3IDE5OSIvPgogICAgPHBvbHlnb24gZGF0YS1pZD0iQS4xLjgiIHBvaW50cz0iNzEzIDIxMSA4OTIgMjExIDg5MiAzNzUgODEwLjU1IDM3NSA4MTAuNTUgMzM5IDcxMyAzMzkgNzEzIDIxMSIvPgogICAgPHJlY3QgZGF0YS1pZD0iQS4xLjkiIHg9IjcxMi42NiIgeT0iMzgwIiB3aWR0aD0iMTkxLjM0IiBoZWlnaHQ9IjE1OCIvPgogICAgPHBvbHlnb24gZGF0YS1pZD0iQS4xLjEwIiBwb2ludHM9IjcwOCAzODAgNzA4IDUzOCA1ODkuOTggNTM4IDU4OS45OCAzOTAgNjE1IDM5MCA2MTUgMzgwIDcwOCAzODAiLz4KICAgIDxwb2x5Z29uIGRhdGEtaWQ9IkEuMS4xMSIgcG9pbnRzPSI1ODUgMzkwLjQ2IDU4NSA1MjAgNDY2Ljc0IDUyMCA0NjYuNzQgMzgwIDU1OSAzODAgNTU5IDM5MCA1ODUgMzkwLjQ2Ii8+Cjwvc3ZnPg==";
export { SvgPA1 as ReactComponent };